export default [
  {
    path: '/books-guide',
    name: 'booksGuideApp',
    component: () => import(/* webpackChunkName: "booksGuideApp" */'@/views/guide/guide-app'),
    children: [
      {
        path: 'korean/:id',
        name: 'booksGuideKorean',
        component: () => import(/* webpackChunkName: "booksGuideKorean" */'@/views/guide/books/korean-guide'),
      },
      {
        path: 'english/:id',
        name: 'booksGuideEnglish',
        component: () => import(/* webpackChunkName: "booksGuideEnglish" */'@/views/guide/books/english-guide'),
      },
      {
        path: 'no-guide',
        name: 'noGuide',
        component: () => import(/* webpackChunkName: "booksGuideEnglish" */'@/views/guide/books/no-guide.vue'),
      }
    ],
  },

]
